import workspaceQuery from 'graphql/queries/nominal/NominalProductCategoryWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/nominal/NominalProductCategoryListQuery.graphql';
import instanceQuery from 'graphql/queries/nominal/NominalProductCategoryQuery.graphql';
import defaultQuery from 'graphql/queries/nominal/NominalProductCategoryDefault.graphql';
import mutationQuery from 'graphql/mutations/nominal/NominalProductCategoryMutation.graphql';
import fragment from 'graphql/fragments/nominal/NominalProductCategoryFragment.graphql';

const NominalProductCategory = {
  type: 'NominalProductCategory',
  title: 'Nominal Product Categories',
  formTitle: 'Nominal Product Category',
  formUrl: '/Nominal/ProductCategory/Details/',
  workspaceUrl: '/Nominal/ProductCategory/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'NOMINAL_PRODUCT_CATEGORIES',
};

export default NominalProductCategory;
